import {
  HighlightProps as MantineHighlightProps,
  Highlight as MantineHighlight,
} from '@mantine/core';

export type HighlightProps = MantineHighlightProps;

export const Highlight = MantineHighlight as typeof MantineHighlight;

Highlight.displayName = 'Highlight';
